export const NEW_CANDIDATE = 1

export const EXISTING_CANDIDATE = 2
